export const AUTH_CONSTANTS = {
  FIELD_LABELS: {
    username: 'Usuario',
    password: 'Contraseña',
    rememberMe: 'Recordarme',
  },

  BUTTON_LABELS: {
    login: 'Iniciar Sesión',
    logout: 'Cerrar Sesión',
    loading: 'Iniciando sesión...',
  },

  MESSAGES: {
    welcome: 'Bienvenido de nuevo',
    loginSubtitle: 'Ingresa tus credenciales para acceder',
    forgotPassword: '¿Olvidaste tu contraseña?',
    noAccount: '¿No tienes cuenta?',
    signUp: 'Registrarse',
    loginSuccess: 'Inicio de sesión exitoso',
    logoutSuccess: 'Sesión cerrada correctamente',
  },


  VALIDATION: {
    EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  },

  ROUTES: {
    LOGIN: '/login',
    DASHBOARD: '/dashboard',
    HOME: '/',
  },
} as const;